<template>
  <label class="toggle-switch" :class="{ disabled, 'is-on': modelValue }">
    <input
        type="checkbox"
        :checked="modelValue"
        :disabled="disabled"
        @change="$emit('update:modelValue', $event.target.checked)"
    >
    <span class="toggle-track">
      <span class="toggle-text toggle-text-on">ON</span>
      <span class="toggle-text toggle-text-off">OFF</span>
      <span class="toggle-thumb"></span>
    </span>
  </label>
</template>

<script>
export default {
  name: "ToggleSwitch",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"]
}
</script>

<style scoped>
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 76px;
  height: 34px;
  cursor: pointer;
  flex-shrink: 0;
}
.toggle-switch.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}

.toggle-track {
  position: absolute;
  inset: 0;
  border-radius: 999px;
  background: linear-gradient(160deg, #f7f7f7, #e6e6e6);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.18), inset 0 1px 2px rgba(255, 255, 255, 0.9);
  transition: background .25s ease;
  overflow: hidden;
}
.is-on .toggle-track {
  background: linear-gradient(160deg, var(--primary), #157984);
}

.toggle-text {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  transition: opacity .2s ease;
}
.toggle-text-on {
  left: 11px;
  color: #ffffff;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.25), 0 -1px 0 rgba(255, 255, 255, 0.2);
  opacity: 0;
}
.toggle-text-off {
  right: 10px;
  color: #b5b5b5;
  text-shadow: 0 1px 0 #ffffff, 0 -1px 0 rgba(0, 0, 0, 0.08);
  opacity: 1;
}
.is-on .toggle-text-on {
  opacity: 1;
}
.is-on .toggle-text-off {
  opacity: 0;
}

.toggle-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.35), 0 1px 1px rgba(0, 0, 0, 0.15);
  transition: transform .25s ease;
}
.is-on .toggle-thumb {
  transform: translateX(42px);
}
</style>
